import { styled, css } from "styled-components";

const baseFooter = css`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-top: 1px solid var(--color-line);
  min-height: 64px;
  background: transparent;
  position: relative;
`;

export const FooterContainer = styled.footer`
  ${baseFooter}
  flex-direction: column;
  gap: 2rem;

  @media (max-width: 768px) {
    gap: 16px;
    display: ${(p) => (p.$isFeedView ? "none" : "flex")};
  }
  @media (max-width: 400px) {
    gap: 8px;
  }
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;

  @media (max-width: 400px) {
    gap: 8px;
  }
`;

export const Link = styled.a`
  color: var(--color-text-dim);
  font-family: var(--font-family-primary);
  text-align: center;
  white-space: nowrap;
  font-size: 12px;
  cursor: pointer;
  font-weight: 400;
  letter-spacing: -0.06px;

  &:hover {
    opacity: 1;
    color: var(--color-brand-500);
  }
`;

export const DesktopRow = styled(FooterRow)`
  z-index: 3;
  display: flex;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileRow = styled(FooterRow)`
  display: none;
  z-index: 3;
  @media (max-width: 768px) {
    display: flex;
  }
`;
